import { removeItemFromBasket, selectBasketCanEdit, selectBasketIsEmpty, selectBasketPaymentInProgress } from 'containers/OrderDetails/basketSlice'
import { selectChatUnreadNotifications } from 'containers/Chats/chatSlice'
import DetailsLocation from 'containers/MapDetails/DetailsLocation'
import ConfirmationPopup from 'components/popups/ConfirmationPopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import { ReactComponent as Back } from 'assets/back.svg'
import TimerProvider from './context/Timer/Provider'
import LoginPopup from 'containers/Login/LoginPopup'
import useTranslation from 'hooks/useTranslation'
import { selectLightTheme } from '../../appSlice'
import usePopupState from 'hooks/usePopupState'
import Message from 'components/icons/Message'
import { useHistory } from 'react-router-dom'
import BasketTitle from './basket/Title'
import BasketPopup from './basket/Popup'
import React, { useState } from 'react'
import BasketIcon from './basket/Icon'
import './style.scss'

interface HeaderProps {
  dark?: boolean
  white?: boolean
  flying?: boolean
  rounded?: boolean
  showNotification?: boolean
  backAction?: basic.BasicFunc
}

type Popup = {
  type: 'removeCartPosition'
  cartId: string
} | {
  type: 'basket' | 'login'
}

const Header: React.FC<HeaderProps> = ({ dark = false, white = false, flying = false, rounded = false, showNotification, backAction }) => {
  const [bartekMode, setBartekMode] = useState(false)
  const canEdit = useReduxSelector(selectBasketCanEdit)
  const lightTheme = useReduxSelector(selectLightTheme)
  const basketIsEmpty = useReduxSelector(selectBasketIsEmpty)
  const paymentInProgress = useReduxSelector(selectBasketPaymentInProgress)
  const unreadMessages = useReduxSelector(selectChatUnreadNotifications)
  const { popup, openPopup } = usePopupState<Popup>()

  const { push, replace, goBack, location: { pathname } } = useHistory()
  const { t } = useTranslation('basket')
  const dispatch = useReduxDispatch()

  const isBasketExpanded = popup?.type === 'basket'
  const showBasketTitle = !basketIsEmpty && !paymentInProgress && !pathname.includes('map') && canEdit !== 0

  return (
    <TimerProvider>
      <header className={`--${lightTheme ? 'light' : 'dark'}${dark ? ' --black' : white ? ' --white' : ''}${flying ? ' --flying' : ''}${rounded ? ' --rounded' : ''}`}>
        <div className='group'>
          {(bartekMode && isBasketExpanded)
            ? <div className='s36' />
            : !pathname.match(/^\/(|home|dashboard|account)$/) ? (
              <div
                className='header__back'
                onClick={() => {
                  if (pathname.match(/^\/warehouses\/[^/]+$/)) {
                    replace('/dashboard')
                  } else if (backAction) {
                    backAction()
                  } else if (window.history) {
                    goBack()
                  } else {
                    replace('/')
                  }
                }}>
                <Back />
              </div>
            ) : null}

          {!flying && <div
            className='header__logo'
            onClick={() => {
              if (isBasketExpanded) setBartekMode(bm => !bm)
              else push('/')
            }}>
            {bartekMode && isBasketExpanded
              ? <span>{t('basket')}</span>
              : pathname.startsWith('/mapdetails/')
                ? <DetailsLocation />
                : <i className='icon icon--logo s24' />}
          </div>}

          {(basketIsEmpty || canEdit === 0)
            ? showNotification
              ? <Message
                isNewMessage={!!unreadMessages}
                onClick={() => {
                  if (pathname !== '/chat') {
                    push('/chat')
                  }
                }}
              />
              : <div className='header__emptyElement' />
            : bartekMode && isBasketExpanded
              ? <i
                className='icon icon--close s32'
                onClick={goBack}
              />
              : <BasketIcon
                action={() => {
                  if (paymentInProgress) return
                  if (isBasketExpanded) goBack()
                  else openPopup({ type: 'basket' })
                }}
              />}
        </div>
        {showBasketTitle && <BasketTitle />}
      </header>
      {isBasketExpanded && <BasketPopup />}
      {popup?.type === 'login' && <LoginPopup />}
      {popup?.type === 'removeCartPosition' && <ConfirmationPopup
        okAction={() => {
          dispatch(removeItemFromBasket({ removeIdentifiers: [popup.cartId] }))
          goBack()
        }}
      />}
    </TimerProvider>
  )
}

export default Header